<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.ClientProject') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :subItemFields="subItemFields" :list-url="listUrl"
                    ref="client-project-table" v-on:refresh="resetFilter">
                    <b-button variant="primary" @click="$router.go(-1)">
                        <b-icon icon="arrow-left" class="icon-style"></b-icon>
                    </b-button>
                    
                    <!-- Display Created At Time -->
                    <template #cell(contacts)="{ item }">
                        {{ (item.contacts.length > 0) ? item.contacts.join(', ') : '' }}
                    </template>
                    <template #cell(deals)="{ item }">
                        {{ (item.deals.length > 0) ? item.deals.join(', ') : '' }}
                    </template>
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ $global.utcDateToLocalDate(item.created_at) }}
                            </span>
                        </div>
                    </template>
                </crud-table>

            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";

const FILTER_FORM = {
    integration_id: null // Adding the new filter for integration_id
};
const COLUMN_STATE = (self) => [
    { key: 'expand', label: self.$t('title.expand'), sortable: false },
    { key: 'integration.name', label: self.$t('title.integration'), sortable: true },
    { key: 'name', label: self.$t('title.name'), sortable: true },
    { key: 'email', label: self.$t('title.email'), sortable: true },
    { key: 'owner', label: self.$t('title.owner'), sortable: true },
    { key: 'phone', label: self.$t('title.phone'), sortable: true },
    { key: 'prority', label: self.$t('title.priority'), sortable: true },
    { key: 'status', label: self.$t('title.status'), sortable: true },
    { key: 'contacts', label: self.$t('title.contacts'), sortable: true },
    { key: 'deals', label: self.$t('title.deals'), sortable: true },
    { key: 'timeline', label: self.$t('title.timeline'), sortable: true },
    { key: 'file', label: self.$t('title.file'), sortable: true },
    { key: 'email', label: self.$t('title.email'), sortable: true },
    { key: 'phone', label: self.$t('title.phone'), sortable: true },
    { key: 'company', label: self.$t('title.company'), sortable: true },
    { key: 'created_at', label: self.$t('title.created_at'), sortable: true }
];

export default {
    data() {
        return {
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
            contacts: [],
            columns: [],
            subItemFields: [
                { key: 'name', label: this.$t('title.name') },
                { key: 'people', label: this.$t('title.people') },
                { key: 'status', label: this.$t('title.status') },
                { key: 'date', label: this.$t('title.date') }
            ]
        };
    },
    created() {
        this.columns = COLUMN_STATE(this);
        this.fetchClientProjects();
    },
    methods: {
        async handleUserAction() {
            this.isLoading = true; // optional loading state if needed
            const payload = {
                owners: this.selectedUsers
            };

            try {
                const response = await request({
                    method: 'post',
                    url: '/admin/save/monday/deals',
                    data: payload,
                    headers: {
                        'Content-Type': 'application/json' // Content type for JSON data
                    }
                });

                if (response.status === true) {
                    this.$bvToast.toast('User stored successfully!', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                } else {
                    this.$bvToast.toast('User storage failed.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                }
            } catch (error) {
                console.error("Error storing user IDs:", error);
                this.errorMessage = error.response ? error.response.data.message : error.message;
                // You might also want to show an error toast
                this.$bvToast.toast(this.errorMessage, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.isLoading = false;
            }
        },
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['client-project-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },
        async fetchClientProjects() {
            try {
                const response = await request({
                    method: 'get',
                    url: this.listUrl,
                });
                const clientProjectsData = response.data;

                let customFieldKeys = new Set(); // Store unique custom field names
                let subItemCustomFieldKeys = new Set();

                // Transform data to include custom fields
                const transformedClientProjects = clientProjectsData.map(clientProject => {
                    // let customFieldsObj = {};

                    if (clientProject.sub_items) {
                        clientProject.sub_items.forEach(subItem => {
                            subItem.custom_fields.forEach(subField => {
                                const formattedSubKey = subField.field_name.toLowerCase().replace(/\s+/g, '_'); // Convert to snake_case
                                // customFieldsObj[formattedKey] = field.field_value || ""; // Default empty if null
                                subItemCustomFieldKeys.add(formattedSubKey); // Collect field names
                            });
                        })
                    }

                    if (clientProject.custom_fields) {
                        clientProject.custom_fields.forEach(field => {
                            const formattedKey = field.field_name.toLowerCase().replace(/\s+/g, '_'); // Convert to snake_case
                            // customFieldsObj[formattedKey] = field.field_value || ""; // Default empty if null
                            customFieldKeys.add(formattedKey); // Collect field names
                        });
                    }

                    return { ...clientProject };
                });

                console.log("dsds", customFieldKeys);
                // Merge custom fields into columns
                const customFieldColumns = Array.from(customFieldKeys).map(field => ({
                    key: `${field}`,
                    label: field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()), // Convert back to readable format
                    sortable: true
                }));

                this.columns = [...COLUMN_STATE(this), ...customFieldColumns]; // Merge with base columns
                console.log(this.columns);

                const subItemCustomFieldColumns = Array.from(subItemCustomFieldKeys).map(field => ({
                    key: `${field}`,
                    label: field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()), // Convert back to readable format
                    sortable: true
                }));

                this.subItemFields = [...this.subItemFields, ...subItemCustomFieldColumns];

            } catch (error) {
                console.error("Error fetching client projects:", error);
            }
        }
    },
    computed: {
        listUrl() {
            return `admin/monday/client-projects/${this.$route.params.id || ''}`;
        }
    }
};
</script>
